import { FC, ReactNode } from "react";

const Navbar: FC<{
  left: ReactNode;
  right: ReactNode;
  children: ReactNode;
}> = ({ left, children, right }) => {
  return (
    <div className="navbar">
      <div className="navbar-inner">
        <div className="left">{left}</div>
        <div className="center">{children}</div>
        <div className="right">{right}</div>
      </div>
    </div>
  );
};

export default Navbar;
